import React from 'react';
import PropTypes from 'prop-types';

import NavBar from '../../../components/NavBar2';

import './styles';

export default class CareersHero extends React.Component {
  static propTypes = {
  }

  state = {}

  render() {
    return (
      <div className="CareersHero">
        <div className="center-content center-aligned-m">
          <div className="ui container">
            <h5 className="m-t-0 m-b-1">JOIN SCALABLE PRESS</h5>
            <div className="primary-bg-color accent-bar m-b-1 m-b-2_5-m d-ib" />
            <h1 className="m-a-0 m-b-2">WE'RE 1% OF THE WAY THERE.</h1>
            <div className="p-b-0_5" />
            <div className="m-t-0 m-b-2 fs-2 sub-header">
              At Scalable Press, we build forward-thinking technology to reinvent the mass customization industry. Long term, our goal is to make ordering customized products as simple and inexpensive as ordering normal products.
            </div>
            <div className="p-b-0_5" />
            <a href="#open-positions">
              <div className="ui primary button">
              VIEW OPEN POSITIONS
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/NavBar2/CareersHero/index.jsx